export const HANDLE_COLUMN_INPUT = 'handle_column_input';
export const CLEAR_FROM_STATE = 'clear';
export const HANDLE_NAME_INPUT = 'name';
export const SET_ALL_TEMPLATES = 'all_templates';
export const ADD_TEMPLATE_TO_TABLE = 'add';
export const SET_TEMPLATE_ID  = 'id';
export const SET_TEMPLATE_STATE  = 'specific_template_state';
export const OPEN_MODAL = 'open_modal';
export const HANDLE_SECONDARY_ROW_COMMAND = 'handle_secondary_row_command';
export const HANDLE_SECONDARY_ROW_COMMAND_VALUE = 'handle_secondary_row_command_value';
export const HANDLE_INCLUDE_SUBTOTALS = 'handle_include_subtotals';

